const products = [
  {
    id: 0,
    name: "Sony WH-XB910N Wireless NC XB Headphone - Black",
    image: "/images/headphone.avif",
    price: 100,
    discount: 0,
    rate: 4,
    category: "headphone",
  },
  {
    id: 1,
    name: "Soundcore By Anker R50i True Wireless Earbuds 10mm Drivers with Big Bass, Bluetooth 5.3, 30H Playtime, IPX5-Water Resistant, AI",
    image: "/images/iphone-square.jpg",
    price: 89000,
    discount: 30,
    rate: 3,
    category: "headphone",
  },
  {
    id: 2,
    name: "Apple iPhone 15 (128 GB) - Black, IPX5-Water Resistant, AI",
    image: "/images/IPhones.avif",
    price: 100,
    discount: 0,
    rate: 4,
    category: "mobiles",
  },
  {
    id: 3,
    name: "mens ACTIV SPCIAL SPORT SHOES Sneaker",
    image: "/images/iphone-square.jpg",
    price: 19900,
    discount: 50,
    rate: 2,
    category: "electronics",
  },
  {
    id: 4,
    name: "Nokia t10 android tablet (4g + wi-fi) with 8 hd display, stereo speakers with ozo playback, 4gb ram + 64gb rom. ocean blue",
    image: "/images/laptop.jpg",
    price: 10_000,
    discount: 50,
    rate: 1,
    category: "electronics",
  },
];

export default products;
